import { render, staticRenderFns } from "./BusinessNameDocuments.vue?vue&type=template&id=062cf473&scoped=true&"
import script from "./BusinessNameDocuments.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDocuments.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDocuments.vue?vue&type=style&index=0&id=062cf473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062cf473",
  null
  
)

export default component.exports